"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var sizes = {
  md: {
    margin: _tokens.spacing.horizontal.xs,
    padding: _elements.boxPadding.squish.md
  }
};
var _default = sizes;
exports.default = _default;